import { linkToDashboard } from "features/dashboard/links";

export function linkToSettings() {
  return `${linkToDashboard()}/settings`;
}

export function linkToPersonalInformation() {
  return `${linkToSettings()}/personal-information`;
}

export function linkToChangeEmail() {
  return `${linkToPersonalInformation()}/change-email`;
}

export function linkToChangeAvatar() {
  return `${linkToPersonalInformation()}/change-avatar`;
}

export function linkToPasswordUpdate() {
  return `${linkToSettings()}/password`;
}

export function linkToUpgradeSubscription() {
  return `${linkToSettings()}/premium`;
}

export function linkToCancelSubscription(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/cancel/${subscriptionId}`;
}

export function linkToRestartSubscription(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/restart/${subscriptionId}`;
}

export function linkToUpdatePaymentDetails(
  subscriptionId: string = ":subscriptionId"
) {
  return `${linkToUpgradeSubscription()}/payment-details/${subscriptionId}`;
}

export function linkToAddParentByCode(code: string = ":code") {
  return `${linkToPersonalInformation()}/parent/code/${code}/connect`;
}

export function linkToRemoveParent(parentId: string = ":parentId") {
  return `${linkToPersonalInformation()}/parent/${parentId}/disconnect`;
}
